import { ACTION } from 'shared/modules/ekyc/constants/mixpanel';
import Mixpanel from 'shared/vendor/Mixpanel';

export const mixpanelTrackPageViewEvent = (screen: string, props?: any) => {
  const eventName = `${screen} - ${ACTION.PAGE_VIEW}`;
  const propsObj = props ? props : {};

  Mixpanel.trackEvent(eventName, propsObj);
};

export const mixpanelStartTrackPageViewDurationEvent = (screen: string) => {
  const eventName = `${screen} - ${ACTION.PAGE_VIEW}`;

  Mixpanel.timeEvent(eventName);
};

export const mixpanelStopTrackPageViewDurationEvent = (
  screen: string,
  props?: any
) => {
  const eventName = `${screen} - ${ACTION.PAGE_VIEW}`;
  const propsObj = props ? props : {};

  Mixpanel.trackEvent(eventName, propsObj);
};

export const mixpanelTrackClickEvent = (screen: string, props?: any) => {
  const eventName = `${screen} - ${ACTION.CLICK}`;
  const propsObj = props ? props : {};

  Mixpanel.trackEvent(eventName, propsObj);
};

export const mixpanelTrackFieldEditEvent = (screen: string, props?: any) => {
  const eventName = `${screen} - ${ACTION.FIELD_EDIT}`;
  const propsObj = props ? props : {};

  Mixpanel.trackEvent(eventName, propsObj);
};

export const mixpanelTrackSuccess = (screen: string, props?: any) => {
  const eventName = `${screen} - ${ACTION.SUCCESS}`;
  const propsObj = props ? props : {};

  Mixpanel.trackEvent(eventName, propsObj);
};

export const mixpanelTrackError = (screen: string, props?: any) => {
  const eventName = `${screen} - ${ACTION.ERROR}`;
  const propsObj = props ? props : {};

  Mixpanel.trackEvent(eventName, propsObj);
};

export const mixpanelTrackAcceptParentalConsensus = (
  screen: string,
  checked: boolean
) => {
  const eventName = `${screen} - ${ACTION.FIELD_EDIT}`;

  Mixpanel.trackEvent(eventName, {
    Item: 'Parental Consensus',
    'Is Accepted': checked ? 'Yes' : 'No',
  });
};

export const mixpanelTrackSelectIsPEPs = (screen: string, isPEPs: boolean) => {
  const eventName = `${screen} - ${ACTION.FIELD_EDIT}`;

  Mixpanel.trackEvent(eventName, {
    Item: 'PEPs',
    'Is PEPs': isPEPs ? 'Yes' : 'No',
  });
};
